import { Injectable } from '@angular/core';
import * as QRCode from 'qrcode';

@Injectable({
    providedIn: 'root'
})
export class QrCodeService {
    constructor() { }

    async generateQRCode(text: string, width: number = 256): Promise<string> {
        try {
            return await QRCode.toDataURL(text, { width });
        } catch (err) {
            console.error('Error generating QR code:', err);
            throw err;
        }
    }
}
